import React from 'react';

import {Container, StorableSummaryExtras} from 'constants/SampleConstants';
import {Measurement} from 'samples/transfers/Measurements';

interface Props {
  container: Container;
  storableSummaryExtras?: StorableSummaryExtras | null;
}

export default function ContainerConcentration(props: Props): JSX.Element | null {
  if (
    !(
      props.container &&
      props.storableSummaryExtras &&
      props.storableSummaryExtras.containableConcentrationsByContainerId
    )
  ) {
    return null;
  }
  const concentrationsByContainableId =
    props.storableSummaryExtras.containableConcentrationsByContainerId[props.container.id];
  const numContents = concentrationsByContainableId && Object.keys(concentrationsByContainableId).length;
  if (!concentrationsByContainableId || numContents === 0) {
    return <span className="u-faded">No contents</span>;
  } else if (numContents > 1) {
    return <span className="u-faded">Multiple contents</span>;
  } else {
    return <Measurement measurement={Object.values(concentrationsByContainableId)[0]} />;
  }
}
